import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Start', path: '/' },
  { label: 'Leistungen', path: '/leistungen' },
  { label: 'Über mich', path: '/ueber-mich' },
  { label: 'Termin', path: '/termin' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-transparent">
      {/* Desktop Floating Bar */}
      <div className="hidden md:block">
        <div className="pt-5 px-4">
          <nav
              className="nav-drop-in mx-auto max-w-[900px] flex items-center justify-between rounded-[50px] px-3 py-2"
              style={{
                background: 'rgba(30,25,22,0.6)',
                backdropFilter: 'blur(25px)',
                WebkitBackdropFilter: 'blur(25px)',
                border: '1px solid rgba(255,255,255,0.15)',
                boxShadow: '0 4px 30px rgba(0,0,0,0.2)',
              }}
            >
            {/* Logo */}
            <Link to="/" className="flex flex-col leading-none pl-5 pr-4">
              <span className="font-serif text-xl font-medium tracking-tight text-[#f0e0d6]">
                Flow <span className="text-[#d4a08a]">&amp;</span> Glow
              </span>
              <span className="text-[9px] tracking-[0.2em] uppercase font-sans text-[#f0e0d6]/60">
                Dein Lächeln zählt
              </span>
            </Link>

            {/* Center Nav Links */}
            <div className="flex items-center gap-1">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`font-sans text-sm font-medium px-5 py-2.5 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    location.pathname === link.path
                      ? 'bg-[#f0e0d6] text-[#3d3330]'
                      : 'text-[#f0e0d6]/90 hover:text-[#f0e0d6] hover:bg-white/10'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </div>

            {/* CTA Button */}
            <Link
              to="/termin"
              className="font-sans text-sm font-medium px-6 py-2.5 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer bg-[#f0e0d6] text-[#3d3330] hover:bg-[#e8cfc0] ml-2"
            >
              Termin buchen
            </Link>
          </nav>
        </div>
      </div>

      {/* Mobile Header */}
      <div className="md:hidden">
        <div
          className={`transition-all duration-500 ${
            scrolled
              ? 'bg-[#3d3330]/90 backdrop-blur-md'
              : menuOpen
              ? 'bg-[#3d3330]/95 backdrop-blur-md'
              : 'bg-transparent'
          }`}
        >
          <div className="max-w-7xl mx-auto px-4 flex items-center justify-between h-16">
            {/* Logo */}
            <Link to="/" className="flex flex-col leading-none group">
              <span className="font-serif text-xl font-medium tracking-tight text-white transition-colors duration-300">
                Flow <span className="text-[#d4a08a]">&amp;</span> Glow
              </span>
              <span className="text-[9px] tracking-[0.18em] uppercase font-sans text-white/70 transition-colors duration-300">
                Dein Lächeln zählt
              </span>
            </Link>

            {/* Mobile: CTA + Hamburger */}
            <div className="flex items-center gap-2">
              <Link
                to="/termin"
                className="font-sans text-xs font-medium px-4 py-2 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer bg-[#f0e0d6] text-[#3d3330]"
              >
                Termin buchen
              </Link>
              <button
                className="w-9 h-9 flex items-center justify-center cursor-pointer text-white transition-colors duration-200"
                onClick={() => setMenuOpen((v) => !v)}
                aria-label="Menü öffnen"
              >
                <i className={menuOpen ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'} />
              </button>
            </div>
          </div>
        </div>

        {/* Mobile menu */}
        {menuOpen && (
          <div className="bg-[#3d3330]/95 backdrop-blur-md px-4 pb-6 pt-2 flex flex-col border-t border-white/10">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`font-sans text-base font-medium py-3.5 border-b border-white/10 cursor-pointer transition-colors duration-200 ${
                  location.pathname === link.path ? 'text-[#f0e0d6] font-semibold' : 'text-white/80 hover:text-white'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        )}
      </div>
    </header>
  );
}
